<template>
  <div class="side-wrapper">
    <el-menu class="el-menu-vertical-demo"
             :collapse="isCollapse"
             :unique-opened="false"
             router
             :default-active="$route.path"
             :collapse-transition="false"
    >
      <div class="taggle" @click=handleIsCollapse>
        <span><i v-show="isCollapse" class="el-icon-s-unfold"></i></span>
        <span><i v-show="!isCollapse" class="el-icon-s-fold"></i></span>
      </div>

      <template v-for="(item, index) of sidebarMenu" v-if="item.menuShow">
        <el-submenu v-if="!item.leaf"
                    :index="index + ''"
                    :key="index + ''"
        >
          <template slot="title">
            <i :class="item.iconCls" class="icon-font"></i>
            <span slot="title">{{item.name}}</span>
          </template>
          <el-menu-item-group v-for="term of item.children" :key="term.name">
            <el-menu-item :index="term.path"
                          :key="term.path"
                          :id="$route.path==term.path?'active':''">
              {{term.name}}
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-menu-item v-else
                      :index="item.children[0].path"
                      :key="item.children[0].name"
                      :id="$route.path==item.children[0].path?'active':''">
          <i :class="item.iconCls" class="icon-font"></i>
          <span slot="title">{{item.name}}</span>
        </el-menu-item>
      </template>

    </el-menu>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'HomeSiderBar',
  data () {
    return {
      isCollapse: false
    }
  },
  computed: {
    ...mapState('permission', ['sidebarMenu', 'currentMenu'])
  },
  methods: {
    handleIsCollapse () {
      this.isCollapse = !this.isCollapse
      this.$emit('change', this.isCollapse)
    }
  }
}
</script>

<style lang="stylus" scoped>
  @import '~styles/variable.styl'

  .el-menu >>> .el-submenu__title
    height 40px
    line-height 40px
    color $sideText

  .el-menu >>> .el-menu-item-group__title
    padding 0

  .el-menu >>> .iconfont
    margin-right 5px

  .el-menu >>> .el-menu-item-group
    .el-menu-item
      padding-left 53px !important

  .el-menu >>> .el-menu-item:hover, .el-submenu .el-menu-item:hover
    background-color: $bgSideHover

  .el-menu >>> .el-submenu__title:hover
    background-color: $bgSideHover

  .el-menu >>> .el-menu--inline
    border-right none
    background-color $bgSide
    color $sideText

  .el-menu >>> .el-submenu__title
    .icon-xitongguanli
      font-size 20px

    .iconfont
      color #ffffff

  .el-menu >>> .icon-sushe
    font-size 24px

  .side-wrapper >>> .icon-icon_tongzhishuguanli
    font-size 20px
    margin-left 1px

  .side-wrapper >>> .icon-shiyongxuesheng
    font-size 26px
    margin-left -1px

  .side-wrapper >>> .icon-feiji
    font-size 22px

  .el-menu
    border-right none
    background-color $bgSide
    color $sideText

    .taggle
      color $sideText
      text-align center
      height 30px
      line-height 30px
      background-color rgba(8, 46, 84, 0.7)
      font-size 20px
      cursor pointer

      span
        cursor pointer

    &.el-menu--popup
      background-color red

    .el-menu-item
      min-width 40px
      height 40px
      line-height 40px
      color $sideText
      &#active
        background-color rgb(0, 63, 109)
        color #fff
      .icon-feiji
        font-size 22px
      .icon-yonghuguanli
        font-size 24px
        margin-left -1px

      .icon-xitongguanli
        font-size 20px

      .icon-icon_tongzhishuguanli
        font-size 20px
        margin-left 1px

  .icon-font
    font-size 16px
    margin-right 4px
    color #ffffff
</style>



// WEBPACK FOOTER //
// src/pages/home/components/HomeSideBar.vue